export const aiTransformationRoute = {
    patterns: {
        aiTransformation: '/ai-transformation',
    },
} as const;
